import { render, staticRenderFns } from "./TaskNoTasksFound.vue?vue&type=template&id=0c27c02c"
import script from "./TaskNoTasksFound.vue?vue&type=script&lang=js"
export * from "./TaskNoTasksFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports